import { useTranslation } from 'react-i18next'
import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'

import AppRouter from 'components/organisms/router/AppRouter'
import { useCustomizedTheme } from 'utils/customHooks/useCustomizedTheme'

const App = () => {
  useTranslation()
  const { theme } = useCustomizedTheme()

  return (
    <div className={'light'}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppRouter />
      </ThemeProvider>
    </div>
  )
}

export default App
